export type ModelValidatorScheema<T> = {
  [K in keyof T]: (value: any) => boolean;
};

export const isValidModel = <T>(obj: any, modelVaidatorsScheema: ModelValidatorScheema<T>): obj is T => {
  if (typeof obj !== 'object' || obj === null) return false;

  return (Object.keys(modelVaidatorsScheema) as Array<keyof T>).every((key) => modelVaidatorsScheema[key](obj[key]));
};
